import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFound = ({ updateLoadingState }) => {
  useEffect(() => {
    updateLoadingState(false);
  }, [updateLoadingState]);

  return (
    <div className="container">
      <h1>404</h1>
      <h2>Oups ! La magie s’est égarée…</h2>
      <p>La page que vous recherchez semble avoir disparu comme par magie. Peut-être est‑elle partie faire un tour dans les attractions ?</p>
      <Link to="/" className="button">Retourner à l’accueil</Link>
    </div>
  );
};

export default NotFound;